import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const ANTIVIRUS_BRAND: 'default' | 'Dr.Web' = getFeature('antivirus-brand') || 'default';

export interface AntivirusConfig {
    show: boolean;
    imageUrl: string;
    href: string;
}

export const antivirusConfig: AntivirusConfig = getFeature('antivirus-config-in-footer') || {
    show: false,
    imageUrl: '',
    href: '',
};
